export default class HtmlHelper {
  public static getRootDivElement(): HTMLElement {
    return document.getElementById('voting-app-public-ui') as HTMLElement;
  }
}